import { render } from "./ViewAddChildPageLinks.vue?vue&type=template&id=09f18013&scoped=true"
import script from "./ViewAddChildPageLinks.vue?vue&type=script&lang=js"
export * from "./ViewAddChildPageLinks.vue?vue&type=script&lang=js"

import "./ViewAddChildPageLinks.vue?vue&type=style&index=0&id=09f18013&lang=scss&scoped=true"
import "./ViewAddChildPageLinks.vue?vue&type=style&index=1&id=09f18013&lang=scss"

import exportComponent from "/app/tmp/origina/V3/v2026.12.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09f18013"]])

export default __exports__